const courseType = [
  { type: 'LECTURE', name: '\u65b0\u8bfe', color: 'geekblue', weight: 10 },
  { type: 'MIN45', name: '45\u5206\u949f\u8bfe', color: 'green', weight: 20 },
  { type: 'MIN60', name: '60\u5206\u949f\u8bfe', color: 'green', weight: 30 },
  { type: 'TUTORIAL', name: '\u6307\u5bfc\u8bfe', color: 'green', weight: 40 },
  { type: 'TRAIL', name: '\u8bd5\u542c\u8bfe', color: 'red', weight: 50 },
  { type: 'MISSING', name: '\u7f3a\u5e2d', color: 'red', weight: 60 },
  { type: 'GROUP', name: 'group', color: 'blueviolet', weight: 70 },
  { type: 'OTHER', name: '\u5176\u5b83', color: 'black', weight: 80 },
];

export default { courseType };
